import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { MyClassesPage } from '@features/groups/components/pages/MyClassesPage'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/classes')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: `My Classes`
        }
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load your classes'>
            <Suspense fallback={<LoadingIndicator resource='your classes'/>}>
                <MyClassesPage />
            </Suspense>
        </QueryErrorBoundary>
    )
}